import NudosGenericSearchBar from './NudosGenericSearchBar';

export default NudosGenericSearchBar;
